const getFutureDateStr = (dateObj: Date, num: number, type: string): string => {
  const date: Date = new Date(dateObj);

  switch (type) {
    case 'month':
      date.setMonth(date.getMonth() + num);
      break;
    case 'week':
      date.setDate(date.getDate() + (num * 7));
      break;
    case 'day':
      date.setDate(date.getDate() + num);
      break;
    default:
      return null;
  }

  const strWithoutTime: string = date.toISOString().split('T')[0];
  const dateArr: string[] = strWithoutTime.split('-');

  return `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;
};

export default getFutureDateStr;